var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{style:(_vm.buttonStyle),attrs:{"type":"primary","icon":_vm.icon,"size":_vm.size,"loading":_vm.loading,"native-type":_vm.nativeType}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }